import { ProductViewConfigurator } from '~/types/configurator';

let label;
let description;
let imageUrl;

export default {
    controls: [
        {
            key: 'material',
            keyLabel: 'material',
            label: 'Material',
            choices: [
                {
                    label: (label = 'White Standard'),
                    detailsModalLabel: label,
                    value: 'standard',
                    detailsModalSubLabel: 'White paper label',
                    description: (description =
                        'A bright white standard paper label with a smooth feel.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Brown Kraft'),
                    detailsModalLabel: label,
                    detailsModalSubLabel: 'Brown, natural textured label',
                    value: 'kraft',
                    description: (description =
                        'Brown paper, similar to the color of a brown paper bag. It has a rough, textured feel that looks natural and earthy.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'White Compostable'),
                    detailsModalLabel: label,
                    detailsModalSubLabel: 'Sustainable label option',
                    value: 'compostable',
                    description: (description =
                        'This label has an organic, white kraft texture with sustainable benefits. It is industrially compostable and has a 6-month shelf life.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Material options:',
            detailsModalSubLabel:
                'Labels are paper based with no matte or gloss finish.',
        },
        {
            key: 'color',
            keyLabel: 'color',
            label: 'Color',
            displayAsImages: true,
            choices: [
                {
                    label: (label = 'White'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/color-custom-white.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'white',
                    description: (description =
                        'Standard white base material allows your artwork to be crisp and bright.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Brown'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/color-custom-brown.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'brown',
                    description: (description =
                        'Provides a natural, organic look and feel.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Color options:',
        },
        {
            key: 'size',
            keyLabel: 'size',
            label: 'Size',
            choices: [
                {
                    label: (label = '2” × 3”'),
                    detailsModalLabel: label,
                    value: '2-x-3',
                },
                {
                    label: (label = '2.75” × 4”'),
                    detailsModalLabel: label,
                    value: '2.75-x-4',
                },
                {
                    label: (label = '3.25” × 4”'),
                    detailsModalLabel: label,
                    value: '3.25-x-4',
                },
                {
                    label: (label = '4” × 6”'),
                    detailsModalLabel: label,
                    value: '4-x-6',
                },
            ],
            modalComponent: 'BagLabelSizeModal',
        },
    ],
} as ProductViewConfigurator;
